import QuizQuestion from "./components/QuizQuestion"; // Assuming this path

export default function QuizView({ quizData, currentQuestionIndex, userAnswers, onAnswerSubmit, previousQuestion }) {
  const currentQuestion = quizData[currentQuestionIndex];

  return (
    <>
      <div className="logo-container">
        <img src="/assets/images/logo-white.png" alt="InjectCo Logo" className="logo-image" />
      </div>
      <div className="quiz-container p-4 md:p-8 max-w-2xl mx-auto bg-white shadow-lg rounded-lg mt-10 font-sans">
        {currentQuestion && ( // Ensure currentQuestion exists
          <>
            <QuizQuestion index={currentQuestionIndex} question={currentQuestion} onAnswer={onAnswerSubmit} currentAnswer={userAnswers[currentQuestion.id]} handleBack={previousQuestion} />
          </>
        )}
        {!currentQuestion && <p>Loading question...</p>} {/* Fallback if question is not ready */}
      </div>
    </>
  );
}
